import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import CheckOut from '../CheckOut/CheckOut';
import { STRIPE_PK } from '../../config';
import React, { useEffect } from 'react';
import YourOrder from '../YourOrder/YourOrder';
import { Grid, LinearProgress, Step, StepLabel, Stepper } from '@material-ui/core';
import { isPhone } from '../../services/deviceService';
import './Payment.scss';
import OrderContext from '../../contexts/orderContext';
import { Order } from '../../models/order';
// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe(STRIPE_PK);

enum ActiveStep {
  YourOrder,
  Checkout
}

interface PaymentProps {
  next: () => void;
};

const Payment = (props: PaymentProps) => {
  // const [activeStep, setActiveStep] = React.useState(ActiveStep.Checkout);
  const [activeStep, setActiveStep] = React.useState(ActiveStep.YourOrder);
  const [currentOrder, setCurrentOrder] = React.useState<Order>({
    addAnalysis: false,
    addLifetimeUpdates: false,
    voucher: undefined,
    voucherCode: undefined
  });

  const nextStep = (freeOfChange: boolean | null = null) => {
    if (freeOfChange)
      props.next();
    else
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
  }

  const stepsContent = [
    {
      component: 
        <YourOrder next={nextStep} />
    },
    {
      component:
        <Elements stripe={stripePromise}>
          <CheckOut next={props.next} back={() => {setActiveStep(ActiveStep.YourOrder)}} />
        </Elements>
    }
  ]
  
  function getStepContent(step: number) {
    return stepsContent[Math.abs(step)];
  }

  function getSteps() {
    return ['Your Options', 'Checkout'];
  }



  const steps = getSteps();

  return (
    <div className='Payment'>
      <OrderContext.Provider value={{
        CurrentOrder:currentOrder,
        SetCurrentOrder: setCurrentOrder
      }}>
        {/* {isPhone() ? <div>
              <LinearProgress className='phone-tutorial-progress' variant="determinate" value={(activeStep + 1) * 20} />
            </div> :
              <Stepper activeStep={activeStep}>
                {steps.map(label => {
                  return (
                    <Step key={label}>
                      <StepLabel>{label}</StepLabel>
                    </Step>
                  );
                })}
              </Stepper>} */}
        <Grid container>
          {getStepContent(activeStep).component}
        </Grid>
      </OrderContext.Provider>
    </div>
     
  )
};

export default Payment;
